import { Signal } from '../core/Signal';

export interface GameStartPayload {
  timestamp: number;
  sceneKey: string;
}

export interface GameEndPayload {
  timestamp: number;
  sceneKey: string;
  reason: 'completed' | 'quit' | 'error';
}

export interface GamePausePayload {
  timestamp: number;
  sceneKey: string;
}

export interface GameResumePayload {
  timestamp: number;
  sceneKey: string;
}

export interface GameOverPayload {
  timestamp: number;
  sceneKey: string;
  finalScore?: number;
  reason?: string;
}

export const createLifecycleSignals = (debugMode: boolean = false) => ({
  gameStart: new Signal<GameStartPayload>('lifecycle.gameStart', debugMode),
  gameEnd: new Signal<GameEndPayload>('lifecycle.gameEnd', debugMode),
  gamePause: new Signal<GamePausePayload>('lifecycle.gamePause', debugMode),
  gameResume: new Signal<GameResumePayload>('lifecycle.gameResume', debugMode),
  gameOver: new Signal<GameOverPayload>('lifecycle.gameOver', debugMode),
});

export type LifecycleSignals = ReturnType<typeof createLifecycleSignals>;
